// Lets an open Drafts column reload when drafts change elsewhere: saved from
// the compose form, or removed after being posted
const listeners = new Set<() => void>();

export const onDraftsChanged = (listener: () => void) => {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
};

export const notifyDraftsChanged = () => {
  listeners.forEach((listener) => {
    listener();
  });
};
